import { Route, Routes } from "react-router-dom";
import { PageArticulos } from "../pages/PageArticulos/PageArticulos";
import { PageCalendario } from "../pages/PageCalendario/PageCalendario";
import { PageClientes } from "../pages/PageClientes/PageClientes";
import { PageEmpresa } from "../pages/PageEmpresa/PageEmpresa";
import { PageHome } from "../pages/PageHome/PageHome";

import { PageAdmin } from "../pages/PageAdmin/PageAdmin";
import { PageAgenda } from "../pages/PageAgenda/PageAgenda";
import { PageContratos } from "../pages/PageContratos/PageContratos";
import { PageCotizaciones } from "../pages/PageCotizaciones/PageCotizaciones";
import { PageEventos } from "../pages/PageEventos/PageEventos";
import { PageReporte } from "../pages/PageReporte/PageReporte";




export const RouterApp = () => {
    return (
        <Routes>
            {/** Home  */}
            <Route path="/*" element={<PageHome />} />
            <Route path="/clientes/*" element={<PageClientes />} />
            <Route path="/empresas/*" element={<PageEmpresa />} />
            <Route path="/calendario/*" element={<PageCalendario />} />
            <Route path="/articulos/*" element={<PageArticulos />} />
            <Route path="/cotizaciones/*" element={<PageCotizaciones />} />
            <Route path="/admins/*" element={<PageAdmin />} />
            <Route path="/evento/*" element={<PageEventos />} />
            <Route path="/reportes/*" element={<PageReporte />} />
            <Route path="/contratos/*" element={<PageContratos />} />
            <Route path="/agenda/*" element={<PageAgenda />} />
        </Routes>
    );
};
